module.exports = __webpack_public_path__ + "img/NO.938e05a9.svg";